module.exports = "<div class=\"form-control component-date-control\"> <div class=date-control style=display:inline-block> <input type=date class=\"ui-calendar ui-width dynamic-form-input date_yy-mm-dd\"/> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/date-control/date-control.wx.html
// module id = 1971
// module chunks = 50